import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { CompanyShare } from 'types/CompanyEntity'

interface DelistedHistoryTableRowProps {
    date: string | null
    share: CompanyShare
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const DelistedHistoryTableRow = ({
    date,
    share,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: DelistedHistoryTableRowProps) => {
    return (
        <TableRow>
            <TableCell>{date}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{share.symbol}</TableCell> : null}
            <TableCell>Avnotering av {share.instrumentName}</TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
